var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-folder"},[_c('div',[_vm._m(0),_c('h1',[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-wrap"},[_c('img',{attrs:{"src":require("./../../assets/images/empty-folder.png")}})])
}]

export { render, staticRenderFns }